
export const industryCardStyles = {
  border: "none",
  display: { xs: "block", md: "flex" },
  gap: { xs: 3, lg: 6 }
}

export const imageContainerStyles = {
  minWidth: { xs: "auto", md: "50%" },
  minHeight: { xs: 170, md: 'auto' },
  overflow: "hidden",
  boxSizing: "border-box",
}

export const imageStyles = {
  width: "100%",
  height: "auto",
  objectFit: "contain",
}